const hsst2 = gsap.timeline({ paused: true });
hsst2.fromTo('.home-service-header .sec-header-content-anim-line', {
    x: 0,
    y: 49,
    z: -41,
    rotationX: -80,
    transformOrigin: '50% 0%',
    opacity: 0,
},
    {
        x: 0,
        y: 0,
        z: 0,
        rotationX: 0,
        transformOrigin: '318px 30px',
        opacity: 1,
        stagger: 0.05,
        duration: 0.9,
        ease: 'power4.out'
    })

ScrollTrigger.create({
    trigger: ".home-service-header",
    start: '0% 70%',
    // end: '100% 70%',
    // markers: true,
    onEnter: () => hsst2.play(),
    onLeaveBack: () => hsst2.reverse()
})

const sta1 = gsap.timeline({ paused: true });
sta1.fromTo('.home-service-content-txt-num span, .home-service-content-txt-title h3, .home-service-content-txt-des p, .home-service-content-txt-arrow .home-service-content-txt-arrow-img', {
    x: -50,
    opacity: 0,
}, {
    x: 0,
    opacity: 1,
    stagger: 0.05,
    duration: 0.9,
    ease: 'power4.out'
})

ScrollTrigger.create({
    trigger: ".home-service-content-txt-list",
    start: "0% 70%",
    // markers: true,
    onEnter: () => sta1.play(),
    onLeaveBack: () => sta1.reverse()
})

const hssc2 = gsap.timeline({ paused: true });
hssc2.fromTo('.home-service-header-cta .contact-cta-wrappr', {
    y: -30,
}, {
    y: 0,
    stagger: 0.05,
    duration: 1,
    ease: "bounce.out",

})
ScrollTrigger.create({
    trigger: ".home-service-header-cta",
    start: '0% 70%',
    // end: '100% 70%',
    // markers: true,
    onEnter: () => hssc2.play(),
    onLeaveBack: () => hssc2.reverse()
})

const Service_img = document.querySelectorAll('.home-service-content-img-list :nth-child(1)');
const Service_item = document.querySelectorAll('.home-service-content-txt-list :nth-child(1)');

Service_img.forEach(function (Service_img_active) {
    Service_img_active.classList.add("active");
});
Service_item.forEach(function (Service_item_active) {
    Service_item_active.classList.add("active");
});

const service_img_all = document.querySelectorAll(".home-service-content-img-list .home-service-content-img-list-item");
const service_item_all = document.querySelectorAll(".home-service-content-txt-list .home-service-content-txt-list-item");

service_img_all.forEach(function (service_img_data, index) {
    service_img_data.setAttribute("data-index", index);
});

service_item_all.forEach(function (service_item_data, index) {
    service_item_data.setAttribute("data-index", index);
});


service_item_all.forEach((service_item_over, index) => {
    service_item_over.addEventListener("mousemove", function () {
        service_img_all.forEach((service_img_content) => {
            service_img_content.classList.remove("active");
        });
        service_item_all.forEach((service_item_over) => {
            service_item_over.classList.remove("active");
        });
        service_img_all[index].classList.add("active");
        service_item_all[index].classList.add("active");
    });
});

const parallaximage2 = document.querySelectorAll('.img-block-img');
parallaximage2.forEach(function (imgeMove) {
    gsap.set(imgeMove, {
        scale: 1.2,
    })
    const imageRect = imgeMove.getBoundingClientRect();
    const heightDifference = imageRect.height - imgeMove.parentElement.offsetHeight;
    gsap.fromTo(imgeMove, {
        y: -heightDifference,
    },
        {
            scrollTrigger: {
                trigger: imgeMove,
                start: 'top center+=30%',
                end: 'bottom+=10% top',
                scrub: true,
                // markers: true,
            },
            y: heightDifference,
            ease: 'none',
        })
})

// hs == home service
const hs = gsap.timeline({
    scrollTrigger: {
        trigger: '.home-service',
        start: "-10% 40%",
        end: "100% 60%",
        scrub: true,
        // markers: true,
    }
})
hs.to('.header-bg', {
    backgroundColor: 'rgb(40, 88, 209)',
}, 'hs')
hs.to('.header-contact-cta-link a', {
    backgroundColor: 'rgb(21, 23, 30)',
}, 'hs')